import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="booking-widget"
export default class extends Controller {
  static targets = ["calendarFrame"]
  static values = {
    event15Url: String,
    event60Url: String,
    selectedType: { type: String, default: "15" }
  }

  connect() {
    console.log("Booking widget controller connected")
    this.updateCalendar()
  }

  // Switch between 15 min and 60 min appointment types
  selectType(event) {
    const type = event.currentTarget.dataset.type
    this.selectedTypeValue = type
    this.updateCalendar()

    // Update button styles
    this.updateButtonStyles(type)
  }

  updateCalendar() {
    const baseUrl = this.selectedTypeValue === "15" ? this.event15UrlValue : this.event60UrlValue
    const params = "?hide_gdpr_banner=1&background_color=ffffff&text_color=0B1D39&primary_color=2E7D32"
    const url = baseUrl + params

    if (this.hasCalendarFrameTarget) {
      this.calendarFrameTarget.src = url
    }
  }

  updateButtonStyles(selectedType) {
    // Find all type selection buttons
    const buttons = this.element.querySelectorAll('[data-action*="booking-widget#selectType"]')

    buttons.forEach(button => {
      const buttonType = button.dataset.type
      const isSelected = buttonType === selectedType

      // Update border color
      if (isSelected) {
        button.classList.remove("border-gray-200")
        button.classList.add("border-emerald-500", "ring-2", "ring-emerald-500")
      } else {
        button.classList.remove("border-emerald-500", "ring-2", "ring-emerald-500")
        button.classList.add("border-gray-200")
      }
    })
  }
}
